import { ReportArrivCell } from './ReportArrivCell';

export default ReportArrivCell;
